<template>
  <Table ref="processCom" class="tableHead " stripe :columns="columns" :data="data">
  </Table>
</template>
<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '进程',
          slot: 'name',
          align: 'center',
          tooltip: true,
        },
        {
          title: '匹配子进程级数',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '窗口标题',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },
        {
          title: '窗口类名',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },
        {
          title: '窗口宽高',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },
        {
          title: '窗口坐标',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },

        {
          title: '窗口样式',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },
        {
          title: '扩展样式',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        },
        {
          title: '操作系统',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '处理方式',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '状态',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '日志状态',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '备注',
          key: 'ppid',
          align: 'center',
          tooltip: true,
        }, {
          title: '操作',
          key: 'ppid',
          align: 'center',
          tooltip: true,
          width: 200,
        },
      ],
      data: []
    }
  }
}
</script>
<style lang="scss" >
.tableHead {

  .ivu-table td,
  .ivu-table th {
    border: none;
  }
}
</style>